// extracted by mini-css-extract-plugin
export default {"Content-default":"theme-default_Content-default__LtQn2","Footer-default":"theme-default_Footer-default__Rwsc2"};